// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"TagsFilter_filterContainer__nLbZ5","title":"TagsFilter_title__66Zhx","form":"TagsFilter_form___q9rX","row":"TagsFilter_row___53NZ"};